export default {
    language: '言語', english: '英語', spanish: 'スペイン語', japanese: '日本語',
    loading: '読み込み中…', submit: '送信', cancel: 'キャンセル', save: '保存', clear: 'クリア', close: '閉じる',
};
